<template>
  <deals-list
    ref="dealsList"
    :media-owners="suppliers"
    :demographics="demographics"
    :organization-type="OrganizationType.EXCHANGE"
    :packages="packages"
    :total-count="totalCount"
    @get-packages="loadPackages"
    @publish-packages="handlePublishPackages"
    @unpublish-packages="handleUnpublishPackages"
    @delete-packages="handleDeletePackages" />
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  import OrganizationType from '@/common/models/memberships/OrganizationType.enum';
  import PackageStatus from '@/common/models/package/PackageStatus.enum';
  import DealsList from '@/common/components/deals/DealsList.vue';

  export default {
    name: 'DealList',
    components: { DealsList },
    data() {
      return {
        packages: [],
        totalCount: 0,
        OrganizationType,
      };
    },
    computed: {
      ...mapState('exchApp', {
        demographics: (state) => state.demographics,
        suppliers: (state) => state.suppliers,
      }),
    },
    methods: {
      ...mapActions(['updatePackageState']),
      ...mapActions('exchApp', ['getSuppliers', 'getDemographics', 'getPackages', 'deletePackage', 'putPackageState']),
      async loadPackages(queryParams) {
        try {
          this.isLoading = true;
          const response = await queryParams.run(this.getPackages);
          if (response) {
            this.packages = response.items.map((p) => {
              p.mediaOwner = this.suppliers.find((s) => s.id === p.organizationID);
              return p;
            });
            this.totalCount = response.totalCount;
          }
        } finally {
          this.isLoading = false;
        }
      },
      async handlePublishPackages(packages) {
        packages.forEach((x) => {
          this.updatePackageState({
            package: x,
            value: PackageStatus.Published,
          });
        });
        await Promise.all(packages.map((x) => this.putPackageState({ instance: x })));
        this.$refs.dealsList.closeModal();
        this.$refs.dealsList.reloadPackages();
      },
      async handleUnpublishPackages(packages) {
        packages.forEach((x) => {
          this.updatePackageState({
            package: x,
            value: PackageStatus.Draft,
          });
        });
        await Promise.all(packages.map((x) => this.putPackageState({ instance: x })));
        this.$refs.dealsList.closeModal();
        this.$refs.dealsList.reloadPackages();
      },
      async handleDeletePackages(packages) {
        await Promise.all(packages.map((x) => this.deletePackage({ instance: x })));
        this.$refs.dealsList.closeModal();
        this.$refs.dealsList.reloadPackages();
      },
    },
    async beforeMount() {
      await Promise.all([this.getSuppliers(), this.getDemographics()]);
    },
  };
</script>

<style scoped></style>
